import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { baseComponents } from "~components/markdown";
import meta from "~generated/meta.json";
import { useGlobalStore } from "~store/global";
import { ButtonGroup, Container, Icon, IconButton, Link, Stack, useColorModeValue } from "@chakra-ui/react";
import { BiCommand } from "react-icons/bi";
import { FaGithub, FaTwitter } from "react-icons/fa";
import ReactMarkdown from "react-markdown";

function content(owner) {
  return "\nContents licensed under [CC BY-NC-SA 4.0](https://griko.dev/cc-by-nc-sa).".concat("  ", "\nMade using [Next.js](https://nextjs.org), [Chakra UI](https://chakra-ui.com),\nand [DatoCMS](https://www.datocms.com). Hosted on [Vercel](https://vercel.com).\n\nMIT License &copy; ", new Date().getFullYear(), "&ndash;present\n[").concat(String(owner), "](.). Version 7.\n").trim();
}

var Footer = function Footer() {
  var _meta$about$socialsJs = meta.about.socialsJson,
      GitHub = _meta$about$socialsJs.GitHub,
      Twitter = _meta$about$socialsJs.Twitter;
  var open = useGlobalStore(React.useCallback(function (store) {
    return store.openCheatsheet;
  }, []));
  var color = useColorModeValue("#000", "whiteAlpha.700");
  return /*#__PURE__*/_jsx(Container, {
    as: "footer",
    color: color,
    maxW: "4xl",
    p: [4, 8],
    children: /*#__PURE__*/_jsxs(Stack, {
      align: "center",
      fontSize: "xs",
      spacing: 4,
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(ReactMarkdown, {
        components: baseComponents,
        children: content(meta.site.seo.siteName)
      }), /*#__PURE__*/_jsxs(ButtonGroup, {
        children: [/*#__PURE__*/_jsx(IconButton, {
          "aria-label": "GitHub",
          as: Link,
          href: GitHub,
          icon: /*#__PURE__*/_jsx(Icon, {
            as: FaGithub
          }),
          isExternal: true,
          rounded: "full",
          target: "_blank",
          variant: "ghost"
        }), /*#__PURE__*/_jsx(IconButton, {
          "aria-label": "Twitter",
          as: Link,
          href: Twitter,
          icon: /*#__PURE__*/_jsx(Icon, {
            as: FaTwitter
          }),
          isExternal: true,
          rounded: "full",
          target: "_blank",
          variant: "ghost"
        }), /*#__PURE__*/_jsx(IconButton, {
          "aria-label": "Open keybinds cheatsheet",
          icon: /*#__PURE__*/_jsx(Icon, {
            as: BiCommand
          }),
          onClick: function onClick() {
            return open();
          },
          rounded: "full",
          variant: "ghost"
        })]
      })]
    })
  });
};

export default Footer;